import { render, staticRenderFns } from "./CollapseButton.vue?vue&type=template&id=0d9de6b2&scoped=true&"
import script from "./CollapseButton.vue?vue&type=script&lang=js&"
export * from "./CollapseButton.vue?vue&type=script&lang=js&"
import style0 from "./CollapseButton.vue?vue&type=style&index=0&id=0d9de6b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9de6b2",
  null
  
)

export default component.exports